import { BaseResource } from './base-resource';
import { WebSocketMessageType } from './web-socket-message-type.enum';

export class WebSocketMessage extends BaseResource {
  topic: string;
  type: WebSocketMessageType;
}
